export enum SidebarMenu {
  PROFILE = "profile",
}

export type Record = {
  title: string;
  date: string;
  sessionId: string;
};

export type PaginatedChatsResponse = {
  pages: PaginatedRecords[];
};

export type PaginatedRecords = {
  records: Record[];
  pagination: {
    perPage: number;
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };
};

export enum AuthActions {
  SIGNIN = "signin",
  SIGNUP = "signup",
}
